import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { Incident, IncidentFilters } from './incident.model';

dayjs.extend(require('dayjs/plugin/utc'));

export type NormalisedIncidents = {
  byId: Record<string, Incident>;
  allIds: Incident['id'][];
};

interface IncidentsPanelState {
  filters: IncidentFilters;
}

export const FORMATTED_TODAY = dayjs().utc().toISOString();

export const FORMATTED_ONE_YEAR_AGO = dayjs()
  .utc()
  .subtract(1, 'year')
  .toISOString();

export const defaultIncidentFilters: IncidentFilters = {
  incidentTypes: [],
  regions: [],
  timeOfDay: [],
  areas: [],
  place: [],
  targets: [],
  startDate: FORMATTED_ONE_YEAR_AGO,
  endDate: FORMATTED_TODAY,
  datePreset: null,
  open: false,
  geo: null,
  alerts: [],
};

export const INITIAL_INCIDENTS_PANEL_STATE: IncidentsPanelState = {
  filters: defaultIncidentFilters,
};

const IncidentsPanelSlice = createSlice({
  name: 'incidentsPanel',
  initialState: INITIAL_INCIDENTS_PANEL_STATE,
  reducers: {
    setIncidentFilters: (
      state,
      action: PayloadAction<Partial<IncidentFilters> | null>
    ) => {
      // Only updates filters explictly mentioned in action
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
});

export const { setIncidentFilters } = IncidentsPanelSlice.actions;

export default IncidentsPanelSlice.reducer;
